import apiRequest from 'client/helpers/apiRequest';
import Homepage from '@interfaces/homepage';

export const fetchHomepage = () => apiRequest.get<Homepage>('/api/homePage');
